import React, { Component } from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import Header from './Header';
import routes from '@/router/routes';

/**
 * 系统页面布局（顶部有Header，下面左侧是menu菜单，下面右侧是内容区域）
 */
export default class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      curNav: '/index'
    }
  }

  componentDidMount() {
    console.log('aaa', this.props.location.key)
    this.setState({ curNav: this.props.location.pathname })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log('nextProps', nextProps)
    this.setState({ curNav: nextProps.location.pathname })
  }


  render() {
    const { curNav } = this.state;
    return (
      <>
        {/* <BrowserRouter> */}
        <Header {...this.props} curNav={curNav} toggleCollapsed={this.toggleCollapsed} />
        <div style={{ position: 'relative', width: '100%', marginTop: 60 }}>
          <Switch>
            {
              routes.map(item => {
                return (
                  <Route
                    key={item.path}
                    path={item.path}
                    exact={true}
                    render={() => <item.component {...this.props} />}
                  />
                )
              })
            }
          </Switch>
        </div>
        {/* </BrowserRouter> */}
      </>
    )
  }
}